// Apache ECharts theme tuned to Shopify Polaris look-and-feel.
// Colors map roughly onto Polaris semantic tokens; typography uses the same
// system stack Polaris uses so charts inherit the host font.
//
// Use via:
//   import * as echarts from 'echarts';
//   import { polarisEchartsTheme } from './polarisEchartsTheme';
//   echarts.registerTheme('polaris', polarisEchartsTheme);
//   <ReactECharts theme="polaris" option={{...}} />

export const polarisEchartsTheme = {
    color: [
        '#6366f1',  // Orders (indigo)         — placed
        '#10b981',  // Fulfilled (emerald)
        '#06b6d4',  // Completed Partial (cyan)
        '#f59e0b',  // Partial (amber)
        '#ef4444',  // Cancelled (red)
        '#8b5cf6',  // spare
        '#22c55e',  // spare
    ],
    backgroundColor: 'transparent',
    textStyle: {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        color: '#202223',
    },
    title: {
        textStyle: { color: '#202223', fontWeight: 600, fontSize: 13 },
        subtextStyle: { color: '#6d7175', fontSize: 12 },
    },
    legend: {
        textStyle: { color: '#374151', fontSize: 11 },
        itemWidth: 12,
        itemHeight: 8,
        itemGap: 14,
    },
    tooltip: {
        backgroundColor: '#ffffff',
        borderColor: '#e1e3e5',
        borderWidth: 1,
        textStyle: { color: '#202223', fontSize: 12 },
        extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.08); border-radius: 6px;',
    },
    grid: {
        borderColor: '#e1e3e5',
        containLabel: true,
    },
    categoryAxis: {
        axisLine:  { lineStyle: { color: '#9ca3af' } },
        axisTick:  { lineStyle: { color: '#9ca3af' } },
        axisLabel: { color: '#6b7280', fontSize: 11 },
        splitLine: { show: false },
    },
    valueAxis: {
        axisLine:  { show: false },
        axisTick:  { show: false },
        axisLabel: { color: '#6b7280', fontSize: 11 },
        splitLine: { lineStyle: { color: '#f3f4f6' } },
    },
    bar: {
        itemStyle: { borderRadius: [2, 2, 0, 0] },
    },
    dataZoom: [{
        type: 'slider',
        height: 18,
        bottom: 4,
        backgroundColor: '#f6f6f7',
        borderColor: '#e1e3e5',
        fillerColor: 'rgba(99, 102, 241, 0.15)',
        handleStyle: { color: '#6366f1', borderColor: '#4f46e5' },
        textStyle: { color: '#6b7280', fontSize: 10 },
    }],
};
